module.exports = __webpack_public_path__ + "static/img/bentian.db3d08d2.png";